export default "__VITE_ASSET__BLADO_HC__"